export default {
  init() {
    var closeBtn = document.getElementById('cookieClose');
    if(closeBtn) {
      closeBtn.addEventListener('click', function(){
        this.closest('.cookie').classList.add('closed');
        setCookie('acceptCookie', 'true', 365);
      });
    };

    function setCookie(cname , cvalue, exdays )  {
      let expires = '';
      if (exdays > 0) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = `expires=${d.toUTCString()}`;
      } else {
        expires = '01 Jan 1970 00:00:01 GMT';
      }
      document.cookie = `${cname}=${cvalue};${expires};path=/`;
    };
  }
}
